/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BudgetDto } from '../models/budget-dto';
import { BudgetDtoPage } from '../models/budget-dto-page';
import { createBudget } from '../fn/budgets/create-budget';
import { CreateBudget$Params } from '../fn/budgets/create-budget';
import { deleteBudget } from '../fn/budgets/delete-budget';
import { DeleteBudget$Params } from '../fn/budgets/delete-budget';
import { DetailedBudgetDto } from '../models/detailed-budget-dto';
import { getBudget } from '../fn/budgets/get-budget';
import { GetBudget$Params } from '../fn/budgets/get-budget';
import { getDetailedBudget } from '../fn/budgets/get-detailed-budget';
import { GetDetailedBudget$Params } from '../fn/budgets/get-detailed-budget';
import { listBudgets } from '../fn/budgets/list-budgets';
import { ListBudgets$Params } from '../fn/budgets/list-budgets';
import { recomputeBudget } from '../fn/budgets/recompute-budget';
import { RecomputeBudget$Params } from '../fn/budgets/recompute-budget';
import { updateBudget } from '../fn/budgets/update-budget';
import { UpdateBudget$Params } from '../fn/budgets/update-budget';

@Injectable({ providedIn: 'root' })
export class BudgetsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listBudgets()` */
  static readonly ListBudgetsPath = '/v0/budgets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listBudgets()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBudgets$Response(params?: ListBudgets$Params, context?: HttpContext): Observable<StrictHttpResponse<BudgetDtoPage>> {
    return listBudgets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listBudgets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBudgets(params?: ListBudgets$Params, context?: HttpContext): Observable<BudgetDtoPage> {
    return this.listBudgets$Response(params, context).pipe(
      map((r: StrictHttpResponse<BudgetDtoPage>): BudgetDtoPage => r.body)
    );
  }

  /** Path part for operation `getBudget()` */
  static readonly GetBudgetPath = '/v0/budgets/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBudget()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBudget$Response(params: GetBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<BudgetDto>> {
    return getBudget(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBudget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBudget(params: GetBudget$Params, context?: HttpContext): Observable<BudgetDto> {
    return this.getBudget$Response(params, context).pipe(
      map((r: StrictHttpResponse<BudgetDto>): BudgetDto => r.body)
    );
  }

  /** Path part for operation `updateBudget()` */
  static readonly UpdateBudgetPath = '/v0/budgets/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBudget()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBudget$Response(params: UpdateBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateBudget(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBudget$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBudget(params: UpdateBudget$Params, context?: HttpContext): Observable<void> {
    return this.updateBudget$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createBudget()` */
  static readonly CreateBudgetPath = '/v0/budgets/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBudget()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBudget$Response(params: CreateBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<BudgetDto>> {
    return createBudget(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBudget$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBudget(params: CreateBudget$Params, context?: HttpContext): Observable<BudgetDto> {
    return this.createBudget$Response(params, context).pipe(
      map((r: StrictHttpResponse<BudgetDto>): BudgetDto => r.body)
    );
  }

  /** Path part for operation `deleteBudget()` */
  static readonly DeleteBudgetPath = '/v0/budgets/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBudget()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBudget$Response(params: DeleteBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteBudget(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBudget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBudget(params: DeleteBudget$Params, context?: HttpContext): Observable<void> {
    return this.deleteBudget$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getDetailedBudget()` */
  static readonly GetDetailedBudgetPath = '/v0/budgets/{id}/details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDetailedBudget()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDetailedBudget$Response(params: GetDetailedBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<DetailedBudgetDto>> {
    return getDetailedBudget(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDetailedBudget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDetailedBudget(params: GetDetailedBudget$Params, context?: HttpContext): Observable<DetailedBudgetDto> {
    return this.getDetailedBudget$Response(params, context).pipe(
      map((r: StrictHttpResponse<DetailedBudgetDto>): DetailedBudgetDto => r.body)
    );
  }

  /** Path part for operation `recomputeBudget()` */
  static readonly RecomputeBudgetPath = '/v0/budgets/{id}/recompute';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recomputeBudget()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  recomputeBudget$Response(params: RecomputeBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return recomputeBudget(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recomputeBudget$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  recomputeBudget(params: RecomputeBudget$Params, context?: HttpContext): Observable<void> {
    return this.recomputeBudget$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
